import { render } from "./Index.vue?vue&type=template&id=4e8c4a7e"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render

export default script